import { TextStyle } from '../store/editorStore';

export const useItemStyles = () => {
  // Style mặc định cho text component
  const defaultTextStyle: TextStyle = {
    color: '#000000',
    backgroundColor: 'transparent',
    fontSize: 16,
    fontWeight: 'normal',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    textOutlineWidth: 0,
    textOutlineColor: '#000000',
    borderWidth: 0,
    borderColor: '#000000',
    padding: 5,
    borderRadius: 0,
  };

  // Style mặc định cho variable component - chỉ giữ lại text cơ bản
  const defaultVariableStyle: TextStyle = {
    color: '#000000',
    backgroundColor: 'transparent',
    fontSize: 16,
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
  };

  // Style mặc định cho AI text component - mở rộng từ text thường
  const defaultAITextStyle: TextStyle = {
    ...defaultTextStyle,
    color: '#333333',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    textAlign: 'left',
  };

  // Tạo style container dựa trên item style
  const createContainerStyle = (style: TextStyle): React.CSSProperties => {
    // Xử lý hiển thị viền khung
    const borderStyle = style.borderWidth && style.borderWidth > 0
      ? `${style.borderWidth}px solid ${style.borderColor || '#ccc'}`
      : 'none';
    
    return {
      width: '100%',
      height: '100%',
      color: style.color || '#000',
      backgroundColor: style.backgroundColor || 'transparent',
      fontSize: `${style.fontSize || 16}px`,
      fontWeight: style.fontWeight || 'normal',
      fontFamily: style.fontFamily || 'Arial, sans-serif',
      textAlign: style.textAlign as any || 'left',
      display: 'flex',
      alignItems: 'center',
      justifyContent: style.textAlign === 'center' ? 'center' : 
                    style.textAlign === 'right' ? 'flex-end' : 'flex-start',
      border: borderStyle,
      borderRadius: style.borderRadius ? `${style.borderRadius}px` : '0',
      padding: style.padding ? `${style.padding}px` : '0',
      boxSizing: 'border-box',
      overflow: 'hidden',
      position: 'relative',
    };
  };

  // Tạo style cho input element
  const createInputStyle = (style: TextStyle): React.CSSProperties => {
    return {
      width: '100%',
      height: '100%',
      border: 'none',
      background: 'transparent',
      color: style.color || '#000',
      fontSize: `${style.fontSize || 16}px`,
      fontWeight: style.fontWeight || 'normal',
      fontFamily: style.fontFamily || 'Arial, sans-serif',
      textAlign: style.textAlign as any || 'left',
      padding: '0',
      margin: '0',
      outline: 'none'
    };
  };

  // Tạo style cho textarea element
  const createTextareaStyle = (style: TextStyle): React.CSSProperties => {
    return {
      ...createInputStyle(style),
      resize: 'none',
      overflow: 'hidden'
    };
  };

  // Tạo style cho text content
  const createTextStyle = (style: TextStyle): React.CSSProperties => {
    const textShadow = style.textOutlineWidth && style.textOutlineWidth > 0
      ? `0 0 ${style.textOutlineWidth}px ${style.textOutlineColor || '#000'}`
      : 'none';

    return {
      width: '100%',
      height: '100%',
      display: 'flex', 
      alignItems: 'center',
      justifyContent: style.textAlign === 'center' ? 'center' : 
                     style.textAlign === 'right' ? 'flex-end' : 'flex-start',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      overflow: 'auto',
      textShadow: textShadow
    };
  };

  return {
    defaultTextStyle,
    defaultVariableStyle,
    defaultAITextStyle,
    createContainerStyle,
    createInputStyle,
    createTextareaStyle,
    createTextStyle
  };
}; 